import { ChangeEvent, useState } from "react";
import Form from "react-bootstrap/Form";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

const MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

const YEAR_RANGE_SPAN = 10;

export interface MonthYearTitlePickerProps {
    title: string;
    currentDate: Date;
    onJump: (year: number, month: number) => void;
}

function buildYearOptions(): number[] {
    const currentYear = new Date().getFullYear();
    const years: number[] = [];
    for (let year = currentYear - YEAR_RANGE_SPAN; year <= currentYear + YEAR_RANGE_SPAN; year++) {
        years.push(year);
    }
    return years;
}

function MonthYearTitlePicker(props: MonthYearTitlePickerProps) {
    const [show, setShow] = useState(false);
    const popoverId = props.currentDate.getTime().toString(); // Unique ID for the popover based on the current date
    const years = buildYearOptions();
    const selectedMonth = props.currentDate.getMonth();
    const selectedYear = years.includes(props.currentDate.getFullYear())
        ? props.currentDate.getFullYear()
        : new Date().getFullYear();

    function handleMonthChange(e: ChangeEvent<HTMLSelectElement>) {
        props.onJump(selectedYear, Number(e.currentTarget.value));
        setShow(false);
    }

    function handleYearChange(e: ChangeEvent<HTMLSelectElement>) {
        props.onJump(Number(e.currentTarget.value), selectedMonth);
        setShow(false);
    }

    const popover = (
        <Popover id={popoverId}>
            <Popover.Body>
                <div className="d-flex gap-2">
                    <Form.Select
                        aria-label="Select month"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                    >
                        {MONTH_NAMES.map((name, index) => (
                            <option
                                key={name}
                                value={index}
                            >
                                {name}
                            </option>
                        ))}
                    </Form.Select>
                    <Form.Select
                        aria-label="Select year"
                        value={selectedYear}
                        onChange={handleYearChange}
                    >
                        {years.map(year => (
                            <option
                                key={year}
                                value={year}
                            >
                                {year}
                            </option>
                        ))}
                    </Form.Select>
                </div>
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={popover}
            show={show}
            onToggle={setShow}
            rootClose
        >
            <button
                type="button"
                className="calendar-title-picker-btn"
            >
                {props.title}
            </button>
        </OverlayTrigger>
    );
}

export default MonthYearTitlePicker;
